import { theme } from '@/styles'

export const sidebarButtonRootSx = {
  width: '100%',
  borderRadius: '3px',
  padding: '11px 5px 11px 13px',
  justifyContent: 'flex-start',
  '&:hover': { backgroundColor: theme.colors.$whiteSmoke },
} as const

export const sidebarButtonRootNoChevronSx = {
  ...sidebarButtonRootSx,
  padding: '11px 13px',
} as const

export const sidebarChevronSx = {
  marginLeft: 'auto',
  '&.Mui-focusVisible, &[aria-expanded="true"]': {
    backgroundColor: 'action.focus',
  },
} as const

export const sidebarMenuAnchorOrigin = { vertical: 'bottom', horizontal: 'left' } as const
export const sidebarMenuTransformOrigin = { vertical: 'top', horizontal: 'left' } as const
export const sidebarMenuSlotProps = { paper: { sx: { mt: '4px' } } } as const
